import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const MoneyWithdraw = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 8H16.4C16.3 8.2 16.2 8.4 16 8.5L13.8 10.7L13.7 10.8C13.6 10.9 13.5 10.9 13.4 11C13.3 11 13.3 11.1 13.2 11.1C13.1 11.1 13.1 11.2 13 11.2C12.9 11.2 12.9 11.2 12.8 11.3C12.7 11.3 12.6 11.4 12.6 11.4C12.5 11.4 12.4 11.4 12.3 11.4C12.2 11.4 12.2 11.4 12.1 11.4C12 11.4 12 11.4 11.9 11.4C11.8 11.4 11.7 11.4 11.6 11.4C11.5 11.4 11.4 11.4 11.4 11.3C11.3 11.3 11.3 11.3 11.2 11.2C11.1 11.2 11.1 11.1 11 11.1C10.9 11.1 10.9 11 10.8 11C10.7 10.9 10.6 10.9 10.5 10.8L10.4 10.7L8 8.5C7.8 8.4 7.7 8.2 7.6 8H4C2.3 8 1 9.3 1 11V19C1 20.7 2.3 22 4 22H20C21.7 22 23 20.7 23 19V11C23 9.4 21.7 8 20 8ZM6 16C5.4 16 5 15.6 5 15C5 14.4 5.4 14 6 14C6.6 14 7 14.4 7 15C7 15.6 6.6 16 6 16ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM18 16C17.4 16 17 15.6 17 15C17 14.4 17.4 14 18 14C18.6 14 19 14.4 19 15C19 15.6 18.6 16 18 16ZM11.3 9.7C11.7 10.1 12.3 10.1 12.7 9.7L15 7.5C15.4 7.1 15.4 6.5 15 6.1C14.6 5.7 14 5.7 13.6 6.1L13 6.6V3C13 2.4 12.6 2 12 2C11.4 2 11 2.4 11 3V6.6L10.5 6.1C10.1 5.7 9.5 5.7 9.1 6.1C8.7 6.5 8.7 7.1 9.1 7.5L11.3 9.7Z"
      fill="currentColor"
    />
  </svg>
)

export default MoneyWithdraw
